<template>
    <div class="readmore-container">
        <div :style="{maxHeight: maxHeightRendered}" class="readmore-content">
            <div ref="content">
                <slot />
            </div>
        </div>
        <div class="readmore__toggle text-center">
            <a class="font-weight-bold system-link" v-if="isOpen && lessEnabled" @click.prevent="toggleOpen" href="#" :title="showLessText">{{ showLessText }} <span class="fa fa-angle-up"></span></a>
            <a class="font-weight-bold system-link" v-if="!isOpen && shouldShowMoreToggle" @click.prevent="toggleOpen" href="#" :title="showMoreText">{{ showMoreText }} <span class="fa fa-angle-down"></span></a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ReadMore',

  props: {
    open: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 180
    },
    showMoreText: {
      type: String,
      default: 'Read More'
    },
    showLessText: {
      type: String,
      default: 'Read Less'
    },
    lessEnabled: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isOpen: this.open,
      height: null
    }
  },

  watch: {
    open (value) {
      this.isOpen = value
    }
  },

  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen;
    },

    getRefsHeight () {
      if (this.$refs.content != null) {
        this.height = this.$refs.content.offsetHeight;
        if(this.height > this.maxHeight) {
          this.maxHeight = this.$refs.content.offsetHeight;
        }
      } 
    }
  },

  computed: {
    shouldShowMoreToggle () {
      return this.height > this.maxHeight
    },
    maxHeightRendered () {
      return this.isOpen ? 'none' : this.maxHeight + 'px'
    }
  },

  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getRefsHeight)
      this.getRefsHeight()
    })
  },

  updated () {
    this.getRefsHeight()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getRefsHeight)
  }
}
</script>

<style lang="scss" scoped>
.readmore-content {
  overflow-y:scroll;
}
</style>
